
import Multiselect from 'vue-multiselect'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
    components: {
        Multiselect
    },
})
export default class SelectButton extends Vue {
    @Prop({ type: String, default: "" }) readonly placeholderText!: string;
    @Prop({ type: String, default: "250px" }) readonly width!: string;
    @Prop({ type: Array, default: () => [] }) readonly options!: any[];
    @Prop({ type: String, default: "", required: false }) readonly preselect!: string;

    value: string = this.preselect;
    handleInput(e: any) {
        this.$emit('input', this.value)
    }
}
